<template>
    <div class="w-full flex items-start gap-x-6">
        <div class="rounded-lg w-[25%] h-[550px] overflow-y-scroll p-3 flex flex-col gap-y-3">
            <h2 class="font-light text-[16px] underline">Liste des collaborateurs</h2>
            <div v-if="!isload" class="flex flex-col gap-y-3">
                <div v-for="user in colabs" :key="user.id" v-on:click="selectedUser(user.id)" v-bind:class="getActiveClass(user.id)" class="p-4 rounded-lg border flex items-center gap-x-4 cursor-pointer">
                    <div class="min-w-10 min-h-10 rounded-full bg-black text-white uppercase text-xl flex items-center justify-center">
                        {{ user.first_name.trim()[0]+""+user.last_name.trim()[0] }}
                    </div>
                    <h1 class="text-xl font-ligth">{{ user.first_name +" "+user.last_name }}</h1>
                </div>
            </div>
        </div>
        <div class="grow p-3">
            <h2 class="text-[16px] font-light underline">Liste des objectifs</h2>
                <div v-if="this.objectifs.length == 0" class="alert bg-black mt-4">
                    <center>Pas de données trouvées</center>
                </div>
                <div v-else class="body mt-2">
                    <div class="table-responsive" v-if="!isLoading">
                        <table class="table table-bordered table-striped table-hover tableEmployee">
                            <thead>
                                <tr>
                                    <th>Titre</th>
                                    <th>Résultat clé</th>
                                    <th>Actions clés</th>
                                    <th>Type d'objectif</th>
                                    <th>Début</th>
                                    <th>Fin</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="objectif in objectifs" :key="objectif.id">
                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.title" type="text" id="title" class="form-control" placeholder="Entrer le titre">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            <textarea v-model="objectif.key_results" name="" id="description" class="form-control" placeholder="Entrer la description"></textarea>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <textarea v-model="objectif.key_actions" name="" id="description" class="form-control" placeholder="Entrer la description"></textarea>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <select v-model="objectif.type" name="obtype" id="obtype" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                            <option value="">Choisissez le type</option>
                                            <option value="PERSONNEL">PERSONNEL</option>
                                            <option value="COLLECTIF">COLLECTIF</option>
                                            <option value="COLLABORATIF">COLLABORATIF</option>
                                        </select>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.start" type="date" name="start" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.end" type="date" name="end" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style="display: flex; justify-content:center" v-else>
                        <div class="preloader pl-size-xs">
                            <div class="spinner-layer pl-indigo">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
export default {
    name : "TeamGoalView",
    components:{},
    props:[],
    data(){
        return {
            isload : true,
            isloading : true,
            user_selected : 0,
            objectifs:[],
            colabs:[]
        }
    },
    mounted(){
        this.getAllMember();
    },
    methods:{
        getAllMember(){
            const id = localStorage.getItem("userId") ?? this.$store.getters.userId;
            API.get("getUserTeam/"+id)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
            .then((data)=>{
                this.colabs = data.data["data"];
                this.user_selected = data.data["data"][0].id;
                this.getAllObjectif(data.data["data"][0].id);
            })
            .catch((error)=>{console.log(error)})
            .finally(()=>{this.isload = false;})
        },
        getAllObjectif(id){
            this.isLoading = true;                                              
            API.get("/goalsByUser/"+id)
            .then((data)=>{
                this.objectifs = data.data.data;
            })
            .catch(e=>{console.log(e)})
            .finally(()=>{this.isLoading = false})
        },
        selectedUser(id){
            if(this.user_selected != id){
                this.getAllObjectif(id);
            }
            this.user_selected = id;
        },
        getActiveClass(id){
            return `${id == this.user_selected ? "bg-gray-100" : "hover:bg-gray-100"}`;
        },
    }
}
</script>